module.exports = __webpack_public_path__ + "img/character_resize_fuse.7d2f593f.webp";